import { FaHeartbeat, FaThermometerHalf, FaWeight, FaRulerVertical } from "react-icons/fa";
import { MdMonitorHeart } from "react-icons/md";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import Table from "react-bootstrap/Table";

type VitalSign = {
	name: string;
	total: number;
};

type Props = {
	totalVitalSigns: VitalSign[];
};

// Função para determinar o ícone baseado no nome do sinal vital
const getVitalSignIcon = (vitalSignName: string) => {
	const name = vitalSignName.toLowerCase();

	if (name.includes("pressão") || name.includes("arterial")) {
		return <FaHeartbeat className="text-danger" />;
	}
	if (name.includes("temperatura")) {
		return <FaThermometerHalf className="text-warning" />;
	}
	if (name.includes("peso")) {
		return <FaWeight className="text-info" />;
	}
	if (name.includes("altura") || name.includes("estatura")) {
		return <FaRulerVertical className="text-success" />;
	}
	if (name.includes("frequência") || name.includes("cardíaca") || name.includes("respiratória")) {
		return <MdMonitorHeart className="text-primary" />;
	}

	return <FaHeartbeat className="text-muted" />;
};

export function VitalSigns({ totalVitalSigns }: Props) {
	// Calcular total geral
	const totalVitalSignsCount = totalVitalSigns.reduce(
		(sum, item) => sum + item.total,
		0
	);

	// Ordenar por quantidade (maior para menor)
	const sortedVitalSigns = [...totalVitalSigns].sort(
		(a, b) => b.total - a.total
	);

	return (
		<Card className="border-0 shadow-sm">
			<Card.Header className="bg-white border-bottom py-3">
				<div className="d-flex align-items-center">
					<FaHeartbeat className="text-muted me-3" size={20} />
					<h6 className="mb-0 text-dark">Sinais Vitais</h6>
				</div>
			</Card.Header>

			<Card.Body className="p-0">
				<div className="overflow-y-scroll" style={{ maxHeight: "500px" }}>
					<Table responsive hover className="mb-0">
						<thead className="bg-light">
							<tr>
								<th className="ps-3 py-3 border-0">Sinal Vital</th>
								<th className="text-center py-3 border-0">Quantidade</th>
								<th className="text-end pe-3 py-3 border-0">Percentual</th>
							</tr>
						</thead>
						<tbody>
							{sortedVitalSigns.map((vitalSign, index) => {
								const percentage = (
									(vitalSign.total / totalVitalSignsCount) *
									100
								).toFixed(1);

								return (
									<tr key={index} className="border-0">
										<td className="ps-3 py-3">
											<div className="d-flex align-items-center">
												<div className="me-3">
													{getVitalSignIcon(vitalSign.name)}
												</div>
												<div>
													<div
														className="fw-medium text-dark"
														style={{ fontSize: "0.9rem" }}
													>
														{vitalSign.name}
													</div>
												</div>
											</div>
										</td>
										<td className="text-center py-3">
											<div className="fw-bold text-dark">
												{vitalSign.total.toLocaleString()}
											</div>
										</td>
										<td className="text-end pe-3 py-3">
											<Badge bg="light" text="dark" className="px-3 py-2">
												{percentage}%
											</Badge>
										</td>
									</tr>
								);
							})}
						</tbody>
					</Table>
				</div>
			</Card.Body>

			<Card.Footer className="bg-light border-top py-3">
				<div className="d-flex justify-content-between align-items-center">
					<div className="text-muted">
						<small>Total de sinais vitais</small>
					</div>
					<div className="fw-bold text-dark">{totalVitalSignsCount.toLocaleString()}</div>
				</div>
			</Card.Footer>
		</Card>
	);
}

